// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__32KXg","ranges":"BmiRanges_ranges__16OJc"};